module.exports = __webpack_public_path__ + "d213469fe29c17bfbef98abef4c5b0ef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/coffee-table.png
// module id = 2782
// module chunks = 0